export async function jsonIf(resp) {
  const result = await resp.json();
  if (!resp.ok) {
    throw { errors: result?.meta?.codes, data: result?.data };
  } else {
    return result;
  }
}
